import { useState } from 'react';

export default function useDelete(url) {
    const [error, setError] = useState();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const call = async(newUrl = null) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/${newUrl ? newUrl : url}`, {
                    method: 'DELETE',

                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (response.ok) {
                return setData({ message: 'Success' });
            }
            try {
                const result = await response.json();
                setError(result);
            } catch (error) {
                setError({ error: { message: 'There was an error processing.' } });
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return [call, data, error, loading];
}